module.exports = __webpack_public_path__ + "static/img/lefttitle.eec08a73.png";